import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Autocomplete, Box, Button, CircularProgress, FormControlLabel, Grid, IconButton, MenuItem, Paper, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { ErrorMessage, Field, FieldArray, FieldProps, useFormikContext } from 'formik';
import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './ShippingInformation.css';

import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { searchAddressOnType } from '../../store/APISlice';
import { clearShippingInformation, getDropDownInformation, getShippingInformation } from '../../store/formSlice';
import { useAppDispatch } from '../../store/store';
import RequiredLabel from '../UtilityComponent/RequiredLabel';
import { formatPhoneNumber } from '../UtilityComponent/validationUtils';
import './ShippingInformation.css';
import SearchSelectComponent from '../../common/searchAndSelect/SearchSelectComponent';

interface AdditionalContact {
  alternateShippingContactName: string;
  alternateShippingContactEmail: string;
  alternateShippingContactPhoneNumber: string;
}

export interface AddressOption {
  locationName: string
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  locationID: string;
}


interface ShippingInformationProps {
  onNext: () => void;
  onBack: () => void;
  values: any;
  errors: any;
  touched: any;
  contactRows: any;
  onContactsChange: (contacts: AdditionalContact[]) => void;
}

export interface AdditionalContacts {
  alternateShippingContactName: string,
  alternateShippingContactEmail: string,
  alternateShippingContactPhoneNumber: string
}


const styles: { [key: string]: CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxWidth: '80%',
    margin: 'auto',
    marginTop: '10px',
    marginBottom: '30px'
  },
  title: {
    color: '#0047BA !important',
    fontSize: '1rem'
  },
  additionalFieldsContainer: {
    width: '100%',
    marginBottom: '1rem'
  },
  additionalFieldsContainerBottom: {
    width: '74%',
    paddingBottom: '10rem',
    float: 'left'
  },
  additionalFieldsContainerRight: {
    width: '24%',
    paddingBottom: '10rem',
    float: 'right'
  },
  fieldGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '10px',
    width: '100%',
    marginTop: '20px'
  },
  fieldGroupRight: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '10px',
    width: '20%',
    marginTop: '20px'
  },
  inputContainer: {
    flex: 1,
    marginRight: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  menuItemProp: {
    fontSize: '0.8rem !important'
  }
}

const generateTimeOptions = (): string[] => {
  const times: string[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute of [0, 30]) {
      times.push(
        `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`
      );
    }
  }
  return times;
};

export const timeOptions = generateTimeOptions();

//const timeOptions: string[] = [];

// Generate time options in HH:MM format
for (let hour = 0; hour < 24; hour++) {
  for (let minute = 0; minute < 60; minute += 30) { // 30-minute increments
    timeOptions.push(`${hour < 10 ? '0' : ''}${hour}:${minute < 10 ? '0' : ''}${minute}`);
  }
}

const ShippingInformation: React.FC<ShippingInformationProps> = ({ onNext, onBack, values, errors, touched, onContactsChange }) => {
  const dispatch = useAppDispatch();
  const [contactRows, setContactRows] = useState([{ id: Date.now() }]);
  const [stateOptions, setStateOptions] = useState<string[]>([]);
  const navigate = useNavigate();
  const dropDownOptions = useSelector(getDropDownInformation)
  // let dockHeightFlag 


  const { values: formikValues, setFieldValue, setFieldError, resetForm, setErrors, setFieldTouched } = useFormikContext<any>();

  // const [addressOptions, setAddressOptions] = useState<AddressOption[]>([]);
  // const [loading, setLoading] = useState(false);
  const addressFieldRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState<number | undefined>(undefined);

  const [showAlternateContacts, setShowAlternateContacts] = useState(false);

  const handleAddMore = () => {
    // console.log('values.additionalContactsList.length',values.additionalContactsList.length)
    if (values.additionalContactsList.length === 0) {
      setShowAlternateContacts(true);
      const newContact = { alternateShippingContactName: '', alternateShippingContactEmail: '', alternateShippingContactPhoneNumber: '' };
      setFieldValue('additionalContactsList', [newContact]);
    }
  };

  const handleRemoveContact = (index: number) => {
    const updatedContacts = values.additionalContactsList.filter((_: any, i: number) => i !== index);
    setFieldValue('additionalContactsList', updatedContacts);
    if (updatedContacts.length === 0) {
      setShowAlternateContacts(false);
    }
  };

  const handleBack = () => {
    resetForm({ values }); // Reset the form state
    setErrors({}); // Clear the errors
    onBack();
  };


  useEffect(() => {
    if (dropDownOptions) {
      const { States } = dropDownOptions;

      if (States && States !== stateOptions) {

        setStateOptions(States);
      }

    }
  }, [dropDownOptions, stateOptions]);

  // useEffect(() => {
  //   if (addressFieldRef.current) {
  //     setDropdownWidth(addressFieldRef.current.offsetWidth);
  //   }
  // }, [addressOptions]);


  interface DynamicContainer {
    id: number;
  }

  const [dynamicContainer, setDynamicContainer] = useState<DynamicContainer | null>(null);



  const addContainer = () => {
    setDynamicContainer({ id: 0 });
  };


  const [additionalContactsList, setAdditionalContactsList] = useState<AdditionalContacts[]>([]);

  useEffect(() => {
    onContactsChange(additionalContactsList);
  }, [additionalContactsList, onContactsChange]);


  const formatTimeTo24Hour = (time: { split: (arg0: string) => [any, any]; }) => {
    const [hours, minutes] = time.split(':');
    return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
  };

  React.useEffect(() => {
    if (values.shippingProductReadyTime) {
      const formattedTime = formatTimeTo24Hour(values.shippingProductReadyTime);
      setFieldValue('shippingProductReadyTime', formattedTime);
    }
  }, [values.shippingProductReadyTime, setFieldValue]);





  const { shippingCompanyName, shippingStreetAddress, shippingCity,
    shippingState, shippingZipCode, shippingDockDoor, shippingDockHeightFlag,
    shippingProductReadyDate, shippingProductReadyTime, shippingContactEmail, shippingContactName, shippingLocationID,
    shipperCloseTime, shippingAdditionalComments, shippingSchedulingType, shippingAlternateContacts, shippingContactPhoneNumber } = useSelector(getShippingInformation);;
  const initialValuesSet = useRef(false);
  const setFieldIfDefined = (field: string, value: any) => {

    if (value !== undefined && !values[field]) {

      setFieldValue(field, value);
    }
  };

  useEffect(() => {
    dispatch(clearShippingInformation());
    let dockDoor = shippingDockDoor !== undefined ? shippingDockDoor : '';

    setFieldIfDefined('shippingCompanyName', shippingCompanyName);
    setFieldIfDefined('shippingStreetAddress', shippingStreetAddress);
    setFieldIfDefined('shippingCity', shippingCity);
    setFieldIfDefined('shippingState', shippingState);
    setFieldIfDefined('shippingZipCode', shippingZipCode);
    setFieldIfDefined('shippingDockDoor', dockDoor);
    setFieldIfDefined('shippingProductReadyDate', shippingProductReadyDate);
    setFieldIfDefined('shippingProductReadyTime', shippingProductReadyTime);
    setFieldIfDefined('shipperCloseTime', shipperCloseTime);

    if (shippingDockHeightFlag !== undefined && !values.shippingDockHeightFlag) {
      setFieldIfDefined('shippingDockHeightFlag', shippingDockHeightFlag ? 'Yes' : 'No');
    }
    setFieldIfDefined('shippingSchedulingType', shippingSchedulingType);
    setFieldIfDefined('shippingContactEmail', shippingContactEmail);
    setFieldIfDefined('shippingContactName', shippingContactName);
    setFieldIfDefined('shippingContactPhoneNumber', shippingContactPhoneNumber)
    setFieldIfDefined('shippingLocationID', shippingLocationID);
    setFieldIfDefined('shippingAdditionalComments', shippingAdditionalComments);
    if (!initialValuesSet.current && shippingAlternateContacts && Array.isArray(shippingAlternateContacts) && shippingAlternateContacts.length > 0) {
      setShowAlternateContacts(true);
      setFieldValue('additionalContactsList', shippingAlternateContacts);
      shippingAlternateContacts.forEach((contact, index) => {
        setFieldValue(`additionalContactsList[${index}].alternateShippingContactName`, contact.contactName);
        setFieldValue(`additionalContactsList[${index}].alternateShippingContactEmail`, contact.contactEmail);
        setFieldValue(`additionalContactsList[${index}].alternateShippingContactPhoneNumber`, contact.contactPhoneNumber);
      });
      initialValuesSet.current = true;
    }

    // Ensure showAlternateContacts is true if additionalContactsList has values
    if (values.additionalContactsList && values.additionalContactsList.length > 0) {
      setShowAlternateContacts(true);
    }
  }, [
    shippingCompanyName,
    shippingStreetAddress,
    shippingCity,
    shippingState,
    shippingZipCode,
    shippingDockDoor,
    shippingDockHeightFlag,
    shippingProductReadyDate,
    shippingProductReadyTime,
    shipperCloseTime,
    shippingAdditionalComments,
    shippingSchedulingType,
    shippingContactEmail,
    shippingContactName,
    shippingContactPhoneNumber,
    shippingLocationID,
    shippingAlternateContacts,
    setFieldValue,
    values,
  ]);



  const handleFormValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (name === 'shippingContactPhoneNumber' || name === 'alternateShippingContactPhoneNumber') {
      const formattedPhoneNumber = formatPhoneNumber(value, 'US');
      setFieldValue(name, formattedPhoneNumber);
    } else {
      setFieldValue(name, value);
    }

  }

  const handleAddressSelect = (selectedAddress: AddressOption) => {
    setFieldValue('shippingStreetAddress', selectedAddress.streetAddress);
    setFieldValue('shippingCity', selectedAddress.city);
    setFieldValue('shippingState', selectedAddress.state);
    setFieldValue('shippingZipCode', selectedAddress.zipCode);
    setFieldValue('shippingLocationID', selectedAddress.locationID);
  };

  const handleShippingDockHeightFlag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFieldValue('shippingDockHeightFlag', value); // Update the values object
  };

  const handleSchedulingFlag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const schedulingFlag = event.target.value;

    setFieldValue('shippingSchedulingType', schedulingFlag); // Update the values object
  };


  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    // const minDate = new Date(, currentDate.getMonth(), currentDate.getDate());
    return year + "-" + month + "-" + day;
  }



  const handleAlternateContactsChange = (event: any, index: any) => {
    const { name, value } = event.target;

    let formattedValue = value;

    if (name === `additionalContactsList[${index}].alternateShippingContactPhoneNumber`) {
      formattedValue = formatPhoneNumber(value, 'US');
    }

    setFieldValue(name, formattedValue);
  };

  const addressValueChange = (name: string, value: string) => {
    setFieldValue(name, value);
  }

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '80px' }}>
        <div style={styles.container}>
          <h2 style={styles.title}>Shipping Information</h2>
          <Grid container spacing={2} style={styles.additionalFieldsContainer}>
            {/* First Row */}
            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Company Name" mandatory={true} />
              <TextField
                id="shippingCompanyName"
                name="shippingCompanyName"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingCompanyName}
                placeholder="Please enter the Company Name"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingCompanyName" component="div" className="error-message" />
            </Grid>

            <Grid item xs={12} sm={6} ref={addressFieldRef}>
              <SearchSelectComponent
                labelName="shippingStreetAddress"
                onValueChange={addressValueChange}
                placeHolder="Please enter the street address of shipping location"
                value={values.shippingStreetAddress}
                onSelect={handleAddressSelect}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <RequiredLabel label="City" mandatory={true} />
              <TextField
                id="shippingCity"
                name="shippingCity"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingCity}
                placeholder="Please enter the City"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingCity" component="div" className="error-message" />
            </Grid>

            {/* Second Row */}
            <Grid item xs={12} sm={3}>
              <RequiredLabel label="State" mandatory={true} />
              <Autocomplete
                options={stateOptions}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="shippingState"
                    name="shippingState"
                    variant="outlined"
                    size="small"
                    margin="dense"
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        fontSize: '0.8rem',
                      },
                    }}
                    required
                    autoComplete="off"
                    fullWidth
                    placeholder="Please select a state"
                  />
                )}
                value={values.shippingState || ''}
                onChange={(event, newValue) => setFieldValue('shippingState', newValue)}
              />
              <ErrorMessage name="shippingState" component="div" className="error-message" />
            </Grid>

            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Zip Code" mandatory={true} />
              <TextField
                id="shippingZipCode"
                name="shippingZipCode"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingZipCode}
                placeholder="Please enter the Zip Code"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingZipCode" component="div" className="error-message" />
            </Grid>

            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Dock Door" />
              <TextField
                id="shippingDockDoor"
                name="shippingDockDoor"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingDockDoor}
                placeholder="Please enter the Dock Door"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingDockDoor" component="div" className="error-message" />
            </Grid>

            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Dock Height Required" mandatory={true} />
              <RadioGroup
                row
                value={values.shippingDockHeightFlag}
                onChange={handleShippingDockHeightFlag}
                sx={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                  sx={{
                    '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                    marginTop: '4px',
                    marginLeft: '5px',
                    marginRight: '0px',
                  }}
                />
                <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                  sx={{
                    '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                    marginTop: '4px',
                    marginLeft: '5px',
                    marginRight: '0px',
                  }}
                />
              </RadioGroup>
              <div style={{ marginTop: '-10px' }}>
                <ErrorMessage name="shippingDockHeightFlag" component="div" className="error-message" />
              </div>
            </Grid>
          </Grid>
          <h2 style={styles.title}>Contact Information at Shipping Location</h2>
          <Grid container spacing={2} style={styles.additionalFieldsContainer}>
            {/* Contact Name */}
            <Grid item xs={12} sm={4}>
              <RequiredLabel label="Contact Name" mandatory={true} />
              <TextField
                id="shippingContactName"
                name="shippingContactName"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingContactName}
                placeholder="Please enter the Contact Name"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingContactName" component="div" className="error-message" />
            </Grid>

            {/* Email */}
            <Grid item xs={12} sm={4}>
              <RequiredLabel label="Email" mandatory={values.shippingContactEmail !== "" || !values.shippingContactPhoneNumber} />
              <TextField
                id="shippingContactEmail"
                name="shippingContactEmail"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingContactEmail}
                placeholder="Please enter the Email"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingContactEmail" component="div" className="error-message" />
            </Grid>

            {/* Spacer with "or" */}
            <Grid item xs={12} sm={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography
                variant="body1"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px", // Reduced font size for "or"
                  whiteSpace: "nowrap",
                  marginBottom: '0px',
                  marginLeft: '5px',
                  marginRight: '5px',
                  marginTop: '35px',
                  color: '#616161',
                }}
              >
                <span style={{ margin: "0 4px" }}>•••••</span>or<span style={{ margin: "0 4px" }}>•••••</span>
              </Typography>
            </Grid>

            {/* Phone Number */}
            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Phone Number" mandatory={values.shippingContactPhoneNumber !== "" || !values.shippingContactEmail} />
              <TextField
                id="shippingContactPhoneNumber"
                name="shippingContactPhoneNumber"
                type="text"
                variant="outlined"
                size="small"
                fullWidth
                margin="dense"
                InputProps={{
                  style: {
                    fontSize: '0.8rem',
                  },
                }}
                autoComplete="off"
                value={values.shippingContactPhoneNumber}
                placeholder="Please enter the Phone Number"
                onChange={handleFormValueChange}
              />
              <ErrorMessage name="shippingContactPhoneNumber" component="div" className="error-message" />
            </Grid>

            {/* Add Alternate Contact Info Button */}
            <Grid item xs={12} sm={9}></Grid>

            {/* Add Alternate Contact Info Button */}
            <Grid item xs={12} sm={3}>
              {!showAlternateContacts && (
                <Button
                  type="button"
                  variant="contained"
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    padding: '0',
                    color: '#0047BA',
                    fontWeight: 'normal',
                    alignItems: 'center',
                    boxShadow: 'none',
                    minWidth: 'unset',
                    marginTop: '10px',
                    fontFamily: 'Helvetica Neue',
                  }}
                  onClick={handleAddMore}
                >
                  <AddCircleIcon fontSize="small" />
                  <span
                    style={{
                      marginLeft: '5px',
                      color: '#0047BA !important',
                      fontSize: '0.8rem',
                      fontWeight: '700',
                    }}
                  >
                    Add Alternate Contact Info
                  </span>
                </Button>
              )}
            </Grid>
          </Grid>
          {showAlternateContacts && values.additionalContactsList?.length > 0 && (
            <>
              <h3 style={styles.title}>Alternate Contacts</h3>
              <div style={styles.additionalFieldsContainer}>
                <FieldArray name="additionalContactsList">
                  {({ push, remove }) => (
                    <>
                      {values.additionalContactsList.map((contact: any, index: number) => (
                        <Grid container spacing={2} sx={{ marginBottom: '16px' }} key={index} alignItems="center">
                          {/* Contact Name */}
                          <Grid item xs={12} sm={3}>
                            <RequiredLabel label="Contact Name" mandatory={false} />
                            <Field name={`additionalContactsList[${index}].alternateShippingContactName`}>
                              {({ field }: FieldProps) => (
                                <TextField
                                  {...field}
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  margin="dense"
                                  InputProps={{
                                    style: {
                                      fontSize: '0.8rem',
                                    },
                                  }}
                                  autoComplete="off"
                                  placeholder="Please enter the Contact Name"
                                  onChange={(event) => handleAlternateContactsChange(event, index)}
                                />
                              )}
                            </Field>
                            {errors.additionalContactsList &&
                              errors.additionalContactsList[index] &&
                              errors.additionalContactsList[index].alternateShippingContactName && (
                                <div className="error-message">
                                  {errors.additionalContactsList[index].alternateShippingContactName}
                                </div>
                              )}
                          </Grid>

                          {/* Email */}
                          <Grid item xs={12} sm={4}>
                            <RequiredLabel label="Email" mandatory={false} />
                            <Field name={`additionalContactsList[${index}].alternateShippingContactEmail`}>
                              {({ field }: FieldProps) => (
                                <TextField
                                  {...field}
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  margin="dense"
                                  InputProps={{
                                    style: {
                                      fontSize: '0.8rem',
                                    },
                                  }}
                                  autoComplete="off"
                                  placeholder="Please enter the Email"
                                  onChange={(event) => handleAlternateContactsChange(event, index)}
                                />
                              )}
                            </Field>
                            {errors.additionalContactsList &&
                              errors.additionalContactsList[index] &&
                              errors.additionalContactsList[index].alternateShippingContactEmail && (
                                <div className="error-message">
                                  {errors.additionalContactsList[index].alternateShippingContactEmail}
                                </div>
                              )}
                          </Grid>

                          {/* Spacer with "or" */}
                          <Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography
                              variant="body1"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                marginBottom: '0px',
                                marginLeft: '5px',
                                marginRight: '5px',
                                marginTop: '35px',
                                color: '#616161',
                              }}
                            >
                              <span style={{ margin: '0 4px' }}>•••••</span>or<span style={{ margin: '0 4px' }}>•••••</span>
                            </Typography>
                          </Grid>

                          {/* Phone Number */}
                          <Grid item xs={12} sm={3}>
                            <RequiredLabel label="Phone Number" mandatory={false} />
                            <Field name={`additionalContactsList[${index}].alternateShippingContactPhoneNumber`}>
                              {({ field }: FieldProps) => (
                                <TextField
                                  {...field}
                                  type="text"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  margin="dense"
                                  InputProps={{
                                    style: {
                                      fontSize: '0.8rem',
                                    },
                                  }}
                                  autoComplete="off"
                                  placeholder="Please enter the Phone Number"
                                  onChange={(event) => handleAlternateContactsChange(event, index)}
                                />
                              )}
                            </Field>
                            {errors.additionalContactsList &&
                              errors.additionalContactsList[index] &&
                              errors.additionalContactsList[index].alternateShippingContactPhoneNumber && (
                                <div className="error-message">
                                  {errors.additionalContactsList[index].alternateShippingContactPhoneNumber}
                                </div>
                              )}
                          </Grid>

                          {/* Add/Remove Buttons */}
                          <Grid item xs={12} sm={1} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                            {values.additionalContactsList.length < 2 && (
                              <IconButton
                                aria-label="addMore"
                                sx={{ marginTop: '25px' }}
                                onClick={() =>
                                  push({
                                    alternateShippingContactName: '',
                                    alternateShippingContactEmail: '',
                                    alternateShippingContactPhoneNumber: '',
                                  })
                                }
                                size="small"
                              >
                                <AddCircleIcon />
                              </IconButton>
                            )}
                            <IconButton
                              aria-label="remove"
                              sx={{ marginTop: '25px' }}
                              onClick={() => handleRemoveContact(index)}
                              size="small"
                            >
                              <RemoveCircleIcon />
                            </IconButton>
                          </Grid>
                        </Grid>
                      ))}
                    </>
                  )}
                </FieldArray>
              </div>
            </>
          )}

          <h2 style={styles.title}>Scheduling Information at Shipping Location</h2>
          <Grid container spacing={2} style={{ width: '100%' }}>
            {/* First Column */}
            <Grid item xs={12} sm={9}>
              <Grid container spacing={2}>
                {/* First Row: Product Ready Date, Product Ready Time, Shipper Close Time */}
                <Grid item xs={12} sm={4}>
                  <RequiredLabel label="Product Ready Date" mandatory={true} />
                  <TextField
                    id="shippingProductReadyDate"
                    name="shippingProductReadyDate"
                    type="date"
                    variant="outlined"
                    size="small"
                    fullWidth
                    margin="dense"
                    sx={{ width: '95%' }}
                    InputProps={{
                      style: { fontSize: '0.8rem' },
                      inputProps: { min: getCurrentDate() },
                    }}
                    autoComplete="off"
                    value={values.shippingProductReadyDate}
                    placeholder="Please enter the Email"
                    onChange={handleFormValueChange}
                  />
                  <ErrorMessage name="shippingProductReadyDate" component="div" className="error-message" />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <RequiredLabel label="Product Ready Time" mandatory={true} />
                  <TextField
                    id="shippingProductReadyTime"
                    name="shippingProductReadyTime"
                    select
                    variant="outlined"
                    size="small"
                    fullWidth
                    margin="dense"
                    sx={{ width: '95%' }}
                    InputProps={{
                      style: { fontSize: '0.8rem' },
                    }}
                    autoComplete="off"
                    value={values.shippingProductReadyTime || ''}
                    placeholder="Please enter the Email"
                    onChange={handleFormValueChange}
                  >
                    {timeOptions.map((timeVal, index) => (
                      <MenuItem key={index} value={timeVal}>
                        {timeVal}
                      </MenuItem>
                    ))}
                  </TextField>
                  <ErrorMessage name="shippingProductReadyTime" component="div" className="error-message" />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <RequiredLabel label="Shipper Close Time" mandatory={true} />
                  <TextField
                    id="shipperCloseTime"
                    name="shipperCloseTime"
                    select
                    variant="outlined"
                    size="small"
                    fullWidth
                    margin="dense"
                    sx={{ width: '95%' }}
                    InputProps={{
                      style: { fontSize: '0.8rem' },
                    }}
                    autoComplete="off"
                    value={values.shipperCloseTime || ''}
                    placeholder="HH:MM"
                    onChange={handleFormValueChange}
                  >
                    {timeOptions.map((timeVal, index) => (
                      <MenuItem key={index} value={timeVal}>
                        {timeVal}
                      </MenuItem>
                    ))}
                  </TextField>
                  <ErrorMessage name="shipperCloseTime" component="div" className="error-message" />
                </Grid>
              </Grid>

              {/* Second Row: Additional Comments */}
              <Grid item xs={12} sx={{ marginTop: '16px' }}> {/* Added marginTop for gap */}
                <RequiredLabel label="Additional Comments" />
                <TextField
                  id="shippingAdditionalComments"
                  name="shippingAdditionalComments"
                  type="text"
                  variant="outlined"
                  size="small"
                  fullWidth
                  margin="dense"
                  sx={{ width: '98%' }}
                  InputProps={{
                    style: { fontSize: '0.8rem' },
                  }}
                  autoComplete="off"
                  value={values.shippingAdditionalComments}
                  placeholder="Please enter any additional comments"
                  onChange={handleFormValueChange}
                />
                <ErrorMessage name="shippingAdditionalComments" component="div" className="error-message" />
              </Grid>
            </Grid>

            {/* Second Column */}
            <Grid item xs={12} sm={3}>
              <RequiredLabel label="Scheduling" mandatory={true} />
              <RadioGroup
                row
                value={values.shippingSchedulingType}
                onChange={handleSchedulingFlag}
                sx={{ display: 'flex' }}
              >
                <div
                  style={{
                    padding: '5.4px',
                    marginTop: '8px',
                    border: '1px solid',
                    borderRadius: '10px',
                    borderColor: '#ada6a6',
                    paddingLeft: '20px',
                  }}
                >
                  <FormControlLabel
                    value="First Come, First Serve"
                    control={<Radio />}
                    label="First Come, First Serve"
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.8rem' } }}
                  />
                  <Typography
                    variant="body1"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      whiteSpace: 'nowrap',
                      color: '#616161',
                    }}
                  >
                    <span style={{ margin: '0 4px' }}>•••••</span>or<span style={{ margin: '0 4px' }}>•••••</span>
                  </Typography>
                  <FormControlLabel
                    value="Appointment Required"
                    control={<Radio />}
                    label="Appointment Required"
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.8rem' } }}
                  />
                </div>
              </RadioGroup>
              <ErrorMessage name="shippingSchedulingType" component="div" className="error-message" />
            </Grid>
          </Grid>
        </div>
      </div>

      <Box
        sx={{
          position: 'fixed', // Keep the buttons fixed at the bottom
          bottom: '60px', // Distance from the bottom of the screen
          left: '8rem', // Maintain position on normal screens
          width: 'calc(100% - 16rem)', // Adjust width dynamically based on left margin
          display: 'flex',
          flexDirection: 'row', // Keep buttons in a row
          justifyContent: 'space-between', // Align Back to the left and Next to the right
          alignItems: 'center',
          padding: '0', // Remove extra padding
          gap: '0', // Remove gaps between buttons
          '@media (max-width: 768px)': {
            left: '1rem', // Adjust left margin for smaller screens
            width: 'calc(100% - 2rem)', // Adjust width for smaller screens
          },
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: '#F6EB39',
            color: '#2E2E38',
            fontFamily: 'Helvetica Neue',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '22px',
            textAlign: 'center',
          }}
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          style={{
            backgroundColor: '#F6EB39',
            color: '#2E2E38',
            fontFamily: 'Helvetica Neue',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '22px',
            textAlign: 'center',
          }}
          onClick={onNext}
        >
          Next
        </Button>
      </Box>
      {/* <NavigationButtons onBack={onBack} onNext={onNext} /> */}
    </div >
  );
};

export default ShippingInformation;

